<style scoped>
    @import url("../../../styles/smartControl/exibAtu.scss");
</style>

<template>
    <div class="box_exibAtu">

        <div class="boxTit" v-if="flagSinc">
            <span class="tit">{{ this.t }}</span>
        </div>

        <!-- LOADING após search btn 
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>-->

        <div class="boxContent" v-if="flagSinc">
            
            <div class="boxValue">
                <v-icon size="72" class="mr-2 elValue" :color="corStatus">mdi-progress-wrench</v-icon>

                <!--<div class="elValue">{{ statusAtu }}</div>-->
                <div class="elValue">{{ statusAtuLocal }}</div>

            </div>

            <div class="boxDate">
                <div class="tDate">Última atualização</div>
                <div class="elDate">{{ dthhmmLocal }}</div>
            </div>
        </div>

        <div class="semDados" v-if="!flagSinc">
            <v-icon size="72" class="mr-2 elValue" color="#F39C12">mdi-progress-wrench</v-icon>
        </div>

    </div>
</template>

<script>
//import axios from 'axios'
import { convHhmmFromUtc } from "../auxSC/handleTimeConv.js";

export default {

    props:['t','statusAtu','date','flagSinc'],

    data() {
        return {
            statusAtuLocal:'Indefinido',
            corStatus:'',

            dthhmmLocal:'', // date string and local hh:mm
        }
    },

    methods:{
        //
    },

    created() {
        //console.log('[created][ExibAtu][props] flagSinc: ',this.flagSinc)

        this.statusAtu == true? this.statusAtuLocal = 'Ligado' : this.statusAtuLocal = 'Desligado'
        this.statusAtu == true? this.corStatus = '#f39c12' : this.corStatus = ''

        // -- Ao receber utc conv para local.
        //console.log('[ExibAtu] date: ',this.date)
        const tzName = this.$store.state.fusoHorarioSC // esperado --> "Europe/Lisbon"
        const [dataStr, hhmmUtc] = this.date.split("-"); // this.date esperado --> "02/05/2026-11:05"
        let hhmmLocal = convHhmmFromUtc(hhmmUtc, tzName, dataStr)
        this.dthhmmLocal = `${dataStr}-${hhmmLocal}`
        //console.log('[ExibAtu] dthhmmLocal: ',this.dthhmmLocal)
    }
}
</script>